<template>
  <div class="page-wrapper">
    <b-container fluid>
      <bo-page-title>
        <div class="ml-2">
          <router-link class="btn m-l-15 router-link-exact-active router-link-active btn-success" to="add-category"><i
            class="fas fa-plus mr-2"></i>
            Add New
          </router-link>
        </div>
      </bo-page-title>
      <template>
				<b-form @submit.prevent="handleSubmit">
          
        </b-form>
      </template>
      <b-card no-body>
        <b-card-header>
          <b-row>
            <b-col lg="5">
              <h5 class="card-title">Article Category</h5>
            </b-col>
            <b-col lg="3">
              <b-form-group>
              <v-select placeholer="Select Status" v-model="selected_status" :options="status"></v-select>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-input-group>
                <b-form-input placeholder="Type keyword then enter..."></b-form-input>
                <b-input-group-append>
                  <b-button variant="success"><i class="fas fa-search"></i></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
        </b-card-header>
        <b-card-body class="p-0">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>Category Name</th>
                <th style="width: 30%;">Description</th>
                <th>Slug</th>
                <th>Count</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="blog_cat in blog" :key="blog_cat.id">
                <td>{{blog_cat.no}}</td>
                <td>{{blog_cat.cat_name}}</td>
                <td>{{blog_cat.desc}}</td>
                <td>{{blog_cat.slug}}</td>
                <td>{{blog_cat.count}}</td>
                <td><span class="badge badge-success">{{blog_cat.status}}</span></td>
                <td>
                  <a href="#" class="icon_action"><i class="ti-marker-alt"></i></a>
                  <a href="#" class="icon_action"><i class="ti-settings"></i></a>
                  <a href="#" class="icon_action"><i class="ti-trash"></i></a>
                </td>
              </tr>
            </tbody>
          </table>
        </b-card-body>
      </b-card>
    </b-container>
  </div>
</template>
<script>
    import GlobalVue from '@/libs/Global.vue'
    export default {
    name: 'Article',
    extends: GlobalVue,
    components: {},
    data() {
      return {
        blog: [{
            no: 1,
            cat_name: 'Accommodation',
            desc: 'Temukan informasi up-to-date seputar support-system di destinasi impian Anda',
            slug: 'Accommodation',
            count: '3',
            status: 'Active'
          },
          {
            no: 2,
            cat_name: 'Xperience',
            desc: 'Rasakan beragam pengalaman tak terlupakan di setiap destinasi yang Anda kunjungi',
            slug: 'Xperience',
            count: '10',
            status: 'Active'
          },
          {
            no: 3,
            cat_name: 'Flight',
            desc: 'Wujudkan perjalanan wisata terbaik, nyaman, aman, dan berkesan di sini',
            slug: 'Flight',
            count: '20',
            status: 'Active'
          }
          
        ],
        selected: 'Y',
        options: [{
            item: 'Y',
            name: 'Active'
          },
          {
            item: 'N',
            name: 'Inactive'
          }
        ],
        selected_level: 'Administrator',
         levels: [
          'Administrator',
          'Content Writter',
          'Editor'
        ],
        selected_status: 'Active',
        status: [
        'Active',
        'Inactive',]
      }
    }
  }
</script>